import { useCallback } from 'react';

import {
  HOST_PLACE_AD_BANNER_NAME,
  PLACE_ON_CIAN_BANNER_BY_VARIANT,
  type TPlaceOnCianBannerVariant,
} from 'shared/constants/placeOnCianBanner';
import { useGuideAnalytics } from 'shared/hooks';

import { BlueBanner } from '../BlueBanner';

export type { TPlaceOnCianBannerVariant };

interface IPlaceOnCianBannerProps {
  variant?: TPlaceOnCianBannerVariant;
}

export const PlaceOnCianBanner: React.FC<IPlaceOnCianBannerProps> = ({ variant = 'default' }) => {
  const { trackPlaceAdClick } = useGuideAnalytics();
  const onButtonClick = useCallback((): void => {
    trackPlaceAdClick(HOST_PLACE_AD_BANNER_NAME);
  }, [trackPlaceAdClick]);

  return (
    <BlueBanner
      mainBanner={PLACE_ON_CIAN_BANNER_BY_VARIANT[variant]}
      onButtonClick={variant === 'host' ? onButtonClick : undefined}
    />
  );
};
